import React from "react";

/* Les billets d'une représentation avec leurs prix (Jen, 31.10.2026 : « indiquer les prix
   dessus », comme Ticketcorner) : « 2 × Plein tarif · 2 × CHF 30.00 … CHF 60.00 », la place
   offerte d'un bénévole, les 0-2 ans gratuits, puis le total payé. Sert à la page du billet,
   à la page « merci » et à « Mes billets » dans l'app. `billet.prix` vient du serveur. */
const chf = (n) => `CHF ${Number(n || 0).toFixed(2)}`;

export default function PrixBillet({ billet, className = "" }) {
  if (!billet?.prix?.length) return null;
  return (
    <table className={`w-full text-[14px] ${className}`} data-testid="billet-prix">
      <tbody>
        {billet.prix.map((l) => (
          <tr key={l.cle} className="border-t" style={{ borderColor: "var(--border)" }}>
            <td className="py-1.5 pr-3 align-top">
              <span className="font-medium">{l.quantite} × {l.libelle}</span>
              {l.prix > 0 && l.quantite > 1 && <span className="block text-[12px] text-[var(--muted)]">{l.quantite} × {chf(l.prix)}</span>}
            </td>
            <td className="py-1.5 text-right align-top whitespace-nowrap tabular-nums">
              {l.cle === "offert" ? "offert" : l.prix > 0 ? chf(l.montant) : "gratuit"}
            </td>
          </tr>
        ))}
        <tr className="border-t-2" style={{ borderColor: "#CBD5E1" }}>
          <td className="pt-2 font-bold">Total payé</td>
          <td className="pt-2 text-right font-bold tabular-nums whitespace-nowrap" data-testid="billet-total">{chf(billet.montant)}</td>
        </tr>
      </tbody>
    </table>
  );
}
